export default __webpack_public_path__ + "static/media/Ocean blues 3.6c4875eb.jpg";